import BaseService from "./base.service";

class TutorService extends BaseService {
  async askGuide(courseId, preparationStage) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`tutor/guides`, {
          course_id: courseId,
          preparation_stage: preparationStage,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getGuide(guideId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`tutor/guides/${guideId}`)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data));
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getCurrentCoursesGuide(courseId, preparationStage) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(
          `tutor/guides/courses/${courseId}/current?preparation_stage=${preparationStage}`,
        )
        .then((response) => {
          resolve(this.responseWrapper(response, response.data));
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  createThread(userId, courseId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`tutor-chats/`, {
          course_id: courseId,
          user_id: userId,
        })
        .then((response) => {
          resolve(this.responseWrapper(response, response.data.data));
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  async sendUserMessage(threadId, message) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`tutor-chats/${threadId}/messages`, {
          body: message,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getThreadMessages(threadId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`tutor-chats/${threadId}/messages`)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data.data));
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getChatAssistantByCourseId(courseId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`tutor-chats?course_id=${courseId}`)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data.data));
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
}

export default new TutorService();
